/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime'
import type { ClonedDatasetResponse, GetDatasetVersionsResponse } from '../models/index'

export interface CreateNewDatasetVersionRequest {
  datasetId: string
  versionLabel: string
}

/**
 * 
 */
export class DatasetVersionControllerApi extends runtime.BaseAPI {
  /**
   */
  async createNewDatasetVersionRaw(
    requestParameters: CreateNewDatasetVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClonedDatasetResponse>> {
    if (requestParameters['datasetId'] == null) {
      throw new runtime.RequiredError(
        'datasetId',
        'Required parameter "datasetId" was null or undefined when calling createNewDatasetVersion().',
      )
    }

    if (requestParameters['versionLabel'] == null) {
      throw new runtime.RequiredError(
        'versionLabel',
        'Required parameter "versionLabel" was null or undefined when calling createNewDatasetVersion().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['versionLabel'] != null) {
      queryParameters['versionLabel'] = requestParameters['versionLabel']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const rsponse = await this.request(
      {
        path: `/private/bot/datasets/{datasetId}/clone`.replace(
          `{${'datasetId'}}`,
          encodeURIComponent(String(requestParameters['datasetId'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(rsponse)
  }

  /**
   */
  async createNewDatasetVersion(
    requestParameters: CreateNewDatasetVersionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClonedDatasetResponse> {
    const response = await this.createNewDatasetVersionRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async getDatasetVersionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GetDatasetVersionsResponse>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/private/bot/datasets`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response)
  }

  /**
   */
  async getDatasetVersions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GetDatasetVersionsResponse> {
    const response = await this.getDatasetVersionsRaw(initOverrides)
    return await response.value()
  }
}
